export const ItemClientStatuses = Object.freeze({
    ORDER_CONFIRMATION: 1,
    UPLOAD_ARTWORK: 2,
    FINAL_APPROVAL: 3,
    IN_PRODUCTION: 4,
    IN_TRANSIT: 5,
    DELIVERED: 6,
})